import { useState } from "react";
import "./MoreInfo.scss";

export const MoreInfo = ({ title, text }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="product-more-info-modal-card">
      <div
        className="product-more-info-modal-card__header"
        onClick={() => setOpen(!open)}
      >
        <h3>{title}</h3>
        <span>{open ? "-" : "+"}</span>
      </div>

      <div
        className={`product-more-info-modal-card__content ${open ? "show" : ""}`}
      >
        <p>{text}</p>
      </div>
    </div>
  );
};
